<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Listado de ventas" :breadcrumb="true" />
			</template>
			<template #actions>
				<div class="hstack gap-2 justify-content-md-end">
					<router-link :to="{ name: 'company.admin.sale.assign' }" class="btn btn-sm btn-neutral rounded-pill">Asignar ventas</router-link>
				</div>
			</template>
		</LayoutHeaderSection>
		<main class="pt-5 pb-10 pb-0 vstack gap-10">
			<LayoutTableMain :results="results" :loading="loading" @goPage="goPage">
				<template #filters>
					<div class="input-group input-group-sm rounded-pill">
						<span class="input-group-text bg-white rounded-start-pill pe-0" id="basic-addon1"><i class="bi bi-search"></i></span>
						<input type="text" v-model="filters.search" class="form-control border-start-0 rounded-end-pill" placeholder="Buscar..." />
					</div>
				</template>
				<template #body>
					<CompanyAdminSaleTableRow v-for="data in results?.data" v-bind:key="data.id" :sale="data" @select="show" />
				</template>
			</LayoutTableMain>
		</main>

		<CompanyAdminSaleModalShow ref="modalShow" />
	</div>
</template>

<script>
	import { ref, reactive, computed, watch, onMounted, inject } from 'vue';
	import router from '@/router';
	import store from '@/store';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CompanyAdminSaleRepository from '@/repositories/modules/Company/Admin/Sale';

	export default {
		setup() {
			const { loading, catchError } = composableForm();
			const $env = inject('$env');
			const results = ref({});
			const filters = reactive({
				search: null,
				orderBy: 'created_at',
				orderMethod: 'desc',
				take: 20,
				page: 1
			});

			const months = {};
			for(var i = 1; i <= 12; i++) months[i] = (i == 1) ? '1 Mes' : `${i} Meses`;

			const getResults = async () => {
				loading.value = true;

				await CompanyAdminSaleRepository.index(filters).then((response) => {
					results.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'company.admin.home' });
				});

				loading.value = false;
			}

			const goPage = (page) => {
				filters.page = page;
				getResults();
			}

			const modalShow = ref(null);
			const show = (sale) => modalShow.value.show(sale);

			const timeout = ref(null);
			watch(() => filters.search, () => {
				if(timeout.value) clearTimeout(timeout.value);
				timeout.value = setTimeout(() => goPage(1), 1000);
			});

			onMounted(getResults);

			return { loading, filters, months, results, goPage, modalShow, show };
		}
	}
</script>